import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function Qualification() {
  return <Section background="light" data-id="element-198">
      <FadeIn data-id="element-199">
        <div className="grid md:grid-cols-2 gap-8" data-id="element-200">
          {/* Para quién es */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-[#1B4332]" data-id="element-201">
            <h3 className="text-xl font-bold mb-6 text-[#1B4332]" data-id="element-202">
              Es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-203">
              {['Te molesta caminar y al día siguiente lo sentís', 'Sentís rigidez al levantarte', 'Las escaleras te exigen demasiado', 'Querés algo simple, sin gimnasio'].map((item, i) => <li key={i} className="flex items-start" data-id="element-204">
                  <Check className="h-5 w-5 text-green-600 mr-3 mt-0.5 flex-shrink-0" data-id="element-205" />
                  <span className="text-gray-700" data-id="element-206">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Para quién NO es */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-t-4 border-gray-300 opacity-90" data-id="element-207">
            <h3 className="text-xl font-bold mb-6 text-gray-700" data-id="element-208">
              No es para vos si:
            </h3>
            <ul className="space-y-4" data-id="element-209">
              {['Tuviste lesión reciente con hinchazón fuerte o no podés apoyar', 'Tenés bloqueo articular o dolor nocturno severo', 'Estás con protocolo postoperatorio específico'].map((item, i) => <li key={i} className="flex items-start" data-id="element-210">
                  <X className="h-5 w-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-211" />
                  <span className="text-gray-600" data-id="element-212">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </FadeIn>
    </Section>;
}